import { meetIvyContent } from '@/config/marketing-content/commercial-pages'
import { AsSeenOn } from '@/components/marketing/as-seen-on'
import { FeatureSpotlightStack } from '@/components/marketing/feature-spotlight-stack'
import { HeroChatInput } from '@/components/marketing/hero-chat-input'
import { MarketingHero } from '@/components/marketing/marketing-hero'
import { MarketingCta } from '@/components/marketing/marketing-cta'

export function MeetIvyPage() {
  return (
    <main>
      <MarketingHero
        eyebrow={meetIvyContent.eyebrow}
        title={meetIvyContent.heroTitle}
        lead={meetIvyContent.heroLead}
      >
        <HeroChatInput />
      </MarketingHero>

      <AsSeenOn title={meetIvyContent.asSeenOnTitle} logos={meetIvyContent.asSeenOnLogos} />

      <section className="brokerage-marquee brokerage-marquee--hero-fold w-full">
        <h2 className="marketing-container brokerage-marquee__title font-bold">
          {meetIvyContent.brokerageTitle}
        </h2>
        <div className="marketing-container">
          <p className="mx-auto max-w-2xl text-balance text-center text-xl text-white">
            {meetIvyContent.brokerageBlurb}
          </p>
        </div>
      </section>

      <FeatureSpotlightStack spotlights={meetIvyContent.featureSpotlights} />

      {/* TestimonialCarousel removed from the homepage for now; the component and
          its content (meetIvyContent.testimonialTitle / .testimonials) are kept so
          it can be re-added later. */}

      <MarketingCta
        title={meetIvyContent.ctaTitle}
        lead={meetIvyContent.ctaLead}
        primaryLabel={meetIvyContent.ctaPrimaryLabel}
        primaryHref={meetIvyContent.ctaPrimaryHref}
      />
    </main>
  )
}
